import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import TopBarLogo from "@components/topbar/TopBarLogo";


const FooterNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md w-full">
      <div className=" px-6 flex justify-between">
        <div className="topbarMenu">
          <div className="topbarLink">
            <TopBarLogo />

            <NavLink to="/" className="text-2xl font-bold flex">
              <span className="text-orange-500">smik</span>
              <span className="text-blue-500">learn</span>
            </NavLink>
          </div>

          {/* Desktop Navigation on the right */}
          <div className="hidden md:flex space-x-6 text-gray-700 font-medium">
            <NavLink to="/resources" className="hover:text-blue-500">Resources</NavLink>
            <NavLink to="/forbusiness" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">yslearn for Business</NavLink>
            <NavLink to="/instructor" className="hover:text-blue-500">Become an Instructor</NavLink>
            <NavLink to="/hire" className="hover:text-blue-500">Hire From Us</NavLink>
            <NavLink to="/reviews" className="hover:text-blue-500">Reviews</NavLink>
          </div>

          {/* Mobile Menu Button (Only visible on small screens) */}
          <button className="md:hidden text-gray-700" onClick={() => setIsOpen(!isOpen)}>
            <FiMenu size={28} />
          </button>
        </div>

        {/* Mobile Menu (Dropdown) */}
        {isOpen && (
          <div className="md:hidden bg-white shadow-md !absolute top-14 left-0 w-full py-3 space-y-3 text-gray-700 text-center">
            <NavLink to="#" className="block py-2 hover:text-blue-500" onClick={() => setIsOpen(false)}>Resources</NavLink>
            <NavLink to="/forbusiness" className="block py-2 hover:text-blue-500" onClick={() => setIsOpen(false)}>yslearn for Business</NavLink>
            <NavLink to="#" className="block py-2 hover:text-blue-500" onClick={() => setIsOpen(false)}>Become an Instructor</NavLink>
            <NavLink to="#" className="block py-2 hover:text-blue-500" onClick={() => setIsOpen(false)}>Hire From Us</NavLink>
            <NavLink to="#" className="block py-2 hover:text-blue-500" onClick={() => setIsOpen(false)}>Reviews</NavLink>
          </div>
        )}
      </div>
    </nav>
  );
};

export default FooterNav;
